import { render, staticRenderFns } from "./YearPlan.vue?vue&type=template&id=2d0bfa3c"
import script from "./YearPlan.vue?vue&type=script&lang=ts"
export * from "./YearPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports